@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.formWrapper {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  position: relative;
  padding-top: 3px;
  .formCard {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    .infoWrapper {
      margin-top:  hevo-toolkit-variables.$spacer * 0.65;
      margin-bottom:  hevo-toolkit-variables.$spacer * 1.25;
    }

    // Action band styled like the Edge wizard's WizardFooter (60px, centred,
    // surface bg, top shadow).
    //
    // `sticky`, NOT `fixed`: a fixed band is removed from flow and, inside this
    // form's ancestors, broke scrolling of the form content outright. Sticky
    // keeps the band in flow — measured pinned to the scroll port's bottom edge
    // at scrollTop 0 — at the cost of spanning the form column rather than the
    // full container. A full-width band needs the buttons rendered outside the
    // scroll area (as the Edge WizardFooter is), not a position change here.
    .fixedWrapper {
      z-index: 10;
      position: sticky;
      bottom: 0;
      min-height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: hevo-toolkit-variables.$spacer-16 hevo-toolkit-variables.$spacer-20;
      background-color: hevo-toolkit-variables.$surface-bg;
      box-shadow: hevo-toolkit-variables.$shadow-bottom-card;
    }
  }

  &.backdrop::after {
    content: ' ';
    background:  hevo-toolkit-variables.$surface-bg-60;
    position: absolute;
    height: 100%;
    width: 100%;
    padding:  hevo-toolkit-variables.$spacer * 0.65 0px;
    top: 0;
    left: 0;
    z-index: 4;
  }

  .hideOverlay {
    z-index: 5;
  }
}
